import { c as _c } from "react/compiler-runtime";
import { useGetBulkDialogContent } from "@components/common/faro-table/bulk-dialog/bulk-dialog-helper";
import { bulkActionResultsSelector, numberOfUpdatingItemsSelector } from "@store/table/table-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";
import { TEAM_DISPLAY_NAME, TEAMS_DISPLAY_NAME } from "@src/constants/team-constants";

/** Determines the content of bulk dialog and bulk success dialog for deleting team */
export function useDeleteTeamsBulkDialogContent() {
  const $ = _c(10);
  const numberOfUpdatingItems = useAppSelector(numberOfUpdatingItemsSelector);
  const {
    numberOfSuccess,
    numberOfErrors
  } = useAppSelector(bulkActionResultsSelector);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      title: `Remove these ${TEAMS_DISPLAY_NAME} from workspace?`,
      description: `When you confirm this action, all the data of these ${TEAMS_DISPLAY_NAME}
       will be lost and cannot be recovered`
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = `Couldn't remove ${numberOfErrors} of ${numberOfUpdatingItems} ${TEAMS_DISPLAY_NAME}`;
  let t2;
  if ($[1] !== t1) {
    t2 = {
      initial: t0,
      failed: {
        title: t1,
        description: `These ${TEAMS_DISPLAY_NAME} couldn't be removed from workspace, check the details and try again.`
      },
      confirmButtonText: "remove",
      entityType: TEAM_DISPLAY_NAME
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const bulkDialogContent = useGetBulkDialogContent(t2);
  let t3;
  if ($[3] !== numberOfSuccess) {
    t3 = nounPluralize({
      counter: numberOfSuccess,
      word: TEAM_DISPLAY_NAME
    });
    $[3] = numberOfSuccess;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${t3} removed`;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      title: t4,
      description: `All selected ${TEAMS_DISPLAY_NAME} have been permanently removed`
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const successDialogContent = t5;
  let t6;
  if ($[7] !== bulkDialogContent || $[8] !== successDialogContent) {
    t6 = {
      bulkDialogContent,
      successDialogContent
    };
    $[7] = bulkDialogContent;
    $[8] = successDialogContent;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}